module.exports = __webpack_public_path__ + "img/analytics-marketing-team-2.5cfb709a.svg";